// extracted by mini-css-extract-plugin
module.exports =  {"collect-wrapper":"UKiYaH9","collectWrapper":"UKiYaH9","collect-btn":"TczBfJY","collectBtn":"TczBfJY","collected":"pVzoA_k"};